import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function ApplyCTA() {
  return (
    <section
      data-testid="apply-cta-section"
      className="relative border-t border-hairline py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <span className="mono-label">[03] Open call</span>
        </div>
        <div className="md:col-span-8">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-15% 0px" }}
            transition={{ duration: 0.7 }}
            className="font-display text-4xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[0.98]"
          >
            Don&apos;t see the right position?
            <br />
            <span className="text-[color:var(--accent)]">Tell us anyway.</span>
          </motion.h2>
          <p className="mt-6 md:mt-8 max-w-[58ch] text-white/70 text-[15px] md:text-[16px] leading-[1.7]">
            We are always interested in connecting with talented technology professionals. If you
            believe your skills could be a great fit for our team, we&apos;d still love to hear
            from you.
          </p>
          <a
            href="#apply"
            data-testid="apply-cta-button"
            className="mt-10 inline-flex items-center gap-3 bg-[color:var(--accent)] hover:bg-[color:var(--accent-hover)] px-6 py-4 text-[14px] font-medium tracking-tight"
          >
            Send your resume <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
